<div class="grid patrons">
    <div class="patron" *ngIf="'dtmMainPageLib.subpage.whereYouCanFly.patrons.ulc' | transloco as name">
        <a [href]="PATRON_LINKS.ulc.url" target="_blank" rel="noopener noreferrer">
            <img
                ngSrc="/assets/images/where-you-can-fly/logo-ulc-color.svg"
                width="149"
                height="80"
                [alt]="name + ('dtmMainPageLib.subpage.whereYouCanFly.patrons.websiteLinkAltTextSuffix' | transloco)"
            />
        </a>
        <ng-container *ngTemplateOutlet="socialLinkTemplate; context: { $implicit: PATRON_LINKS.ulc, name }"></ng-container>
    </div>
    <div class="patron" *ngIf="'dtmMainPageLib.subpage.whereYouCanFly.patrons.warsaw' | transloco as name">
        <a [href]="PATRON_LINKS.warsaw.url" target="_blank" rel="noopener noreferrer"
            ><img
                ngSrc="/assets/images/where-you-can-fly/logo-warszawa-color.svg"
                width="77"
                height="80"
                [alt]="name + ('dtmMainPageLib.subpage.whereYouCanFly.patrons.websiteLinkAltTextSuffix' | transloco)"
            />
        </a>
        <ng-container *ngTemplateOutlet="socialLinkTemplate; context: { $implicit: PATRON_LINKS.warsaw, name }"></ng-container>
    </div>
    <div class="patron" *ngIf="'dtmMainPageLib.subpage.whereYouCanFly.patrons.pansa' | transloco as name">
        <a [href]="PATRON_LINKS.pansa.url" target="_blank" rel="noopener noreferrer"
            ><img
                ngSrc="/assets/images/where-you-can-fly/logo-pansa-color.svg"
                width="129"
                height="80"
                [alt]="name + ('dtmMainPageLib.subpage.whereYouCanFly.patrons.websiteLinkAltTextSuffix' | transloco)"
            />
        </a>
        <ng-container *ngTemplateOutlet="socialLinkTemplate; context: { $implicit: PATRON_LINKS.pansa, name }"></ng-container>
    </div>
    <div class="patron" *ngIf="'dtmMainPageLib.subpage.whereYouCanFly.patrons.warsawPolice' | transloco as name">
        <a [href]="PATRON_LINKS.warsawPolice.url" target="_blank" rel="noopener noreferrer"
            ><img
                ngSrc="/assets/images/where-you-can-fly/logo-warszawa-policja-small.png?onesize"
                width="64"
                height="80"
                [alt]="name + ('dtmMainPageLib.subpage.whereYouCanFly.patrons.websiteLinkAltTextSuffix' | transloco)"
            />
        </a>
        <ng-container *ngTemplateOutlet="socialLinkTemplate; context: { $implicit: PATRON_LINKS.warsawPolice, name }"></ng-container>
    </div>
    <div class="patron" *ngIf="'dtmMainPageLib.subpage.whereYouCanFly.patrons.sop' | transloco as name">
        <a [href]="PATRON_LINKS.sop.url" target="_blank" rel="noopener noreferrer">
            <img
                ngSrc="/assets/images/where-you-can-fly/logo-sop-color.svg"
                width="64"
                height="80"
                [alt]="name + ('dtmMainPageLib.subpage.whereYouCanFly.patrons.websiteLinkAltTextSuffix' | transloco)"
            />
        </a>
        <ng-container *ngTemplateOutlet="socialLinkTemplate; context: { $implicit: PATRON_LINKS.sop, name }"></ng-container>
    </div>
</div>
<ng-template #socialLinkTemplate let-socialLink let-name="name">
    <div class="social-links" *ngIf="socialLink | invoke : assumeSocialLinksType as links">
        <a *ngIf="links.facebook" [href]="links.facebook" rel="noopener noreferrer" target="_blank">
            <img
                ngSrc="/assets/images/where-you-can-fly/icons/facebook.svg"
                width="40"
                height="40"
                [alt]="name + ('dtmMainPageLib.subpage.whereYouCanFly.patrons.facebookLinkAltTextSuffix' | transloco)"
            />
        </a>
        <a *ngIf="links.instagram" [href]="links.instagram" rel="noopener noreferrer" target="_blank">
            <img
                ngSrc="/assets/images/where-you-can-fly/icons/instagram.svg"
                width="40"
                height="40"
                [alt]="name + ('dtmMainPageLib.subpage.whereYouCanFly.patrons.instagramLinkAltTextSuffix' | transloco)"
            />
        </a>
        <a *ngIf="links.youtube" [href]="links.youtube" rel="noopener noreferrer" target="_blank">
            <img
                ngSrc="/assets/images/where-you-can-fly/icons/youtube.svg"
                width="40"
                height="40"
                [alt]="name + ('dtmMainPageLib.subpage.whereYouCanFly.patrons.youtubeLinkAltTextSuffix' | transloco)"
            />
        </a>
        <a *ngIf="links.tiktok" [href]="links.tiktok" rel="noopener noreferrer" target="_blank">
            <img
                ngSrc="/assets/images/where-you-can-fly/icons/tiktok.svg"
                width="40"
                height="40"
                [alt]="name + ('dtmMainPageLib.subpage.whereYouCanFly.patrons.tiktokLinkAltTextSuffix' | transloco)"
            />
        </a>
        <a *ngIf="links.x" [href]="links.x" rel="noopener noreferrer" target="_blank">
            <img
                ngSrc="/assets/images/where-you-can-fly/icons/x.svg"
                width="40"
                height="40"
                [alt]="name + ('dtmMainPageLib.subpage.whereYouCanFly.patrons.xLinkAltTextSuffix' | transloco)"
            />
        </a>
        <a *ngIf="links.linkedin" [href]="links.linkedin" rel="noopener noreferrer" target="_blank">
            <img
                ngSrc="/assets/images/where-you-can-fly/icons/linkedin.svg"
                width="40"
                height="40"
                [alt]="name + ('dtmMainPageLib.subpage.whereYouCanFly.patrons.linkedinLinkAltTextSuffix' | transloco)"
            />
        </a>
        <a *ngIf="links.whatsapp" [href]="links.whatsapp" rel="noopener noreferrer" target="_blank">
            <img
                ngSrc="/assets/images/where-you-can-fly/icons/whatsapp.svg"
                width="40"
                height="40"
                [alt]="name + ('dtmMainPageLib.subpage.whereYouCanFly.patrons.whatsappLinkAltTextSuffix' | transloco)"
            />
        </a>
    </div>
</ng-template>
